import { useState, useEffect } from "react";
import axios from "axios";

import Notification from "../Others/Notification";
import AmraAmraDatePicker from "../Others/AmraAmraDatePicker";

import "./RegisterMember.css";


function RegisterMember() {

    /* =====================================================
       STATES
    ===================================================== */

    const [loadFormInput, setLoadFormInput] = useState(true);
    const [loadMembersData, setLoadMembersData] = useState(true);

    const [error, setError] = useState(null);

    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const [modalShow, setModalShow] = useState(false);

    const [isJunior, setIsJunior] = useState(false);

    const [inputData, setInputData] = useState({});

    const [isSpecialOfferDay, setIsSpecialOfferDay] =
        useState(false);

    const [parentsId, setParentsId] = useState("");
    const [parentsInfo, setParentsInfo] = useState("");

    const [members, setMembers] = useState(null);
    const [validMember, setValidMember] = useState(null);


    /* =====================================================
       API URLS
    ===================================================== */

    const url =
        "https://script.google.com/macros/s/AKfycbzQou_14Gnvwjmktjq3uF_78bbtPUji9Ocz7TMA-bNz0gp9OSQctPTZdLI6ZvVdVonouw/exec";

    const memberUrl =
        "https://script.google.com/macros/s/AKfycbw3zL12yxAeHhFubKpPNm2DXIeINp7_RZYPij4oKjiBzRUuY6aVEFFUCdBQugIeUsMljg/exec";

    const dataUrl =
        "https://amra-amra.se/db/";

    const apiUrl =
        "https://amra-amra.se/emailApi/";


    /* =====================================================
       CURRENT DATE
    ===================================================== */

    const currentDate = new Date();

    const currentDateString =
        currentDate
            .toISOString()
            .split("T")[0];


    /* =====================================================
       LOAD MEMBERSHIP FORM SETTINGS
    ===================================================== */

    useEffect(() => {

        axios
            .get(
                `${dataUrl}?request=memberinput`
            )

            .then((response) => {

                if (
                    response.data !== "" &&
                    response.data[0]
                ) {

                    const data =
                        response.data[0];

                    setInputData(data);


                    const specialOfferDateStart =
                        data.offer_day_start;

                    const specialOfferDateEnd =
                        data.offer_day_end;


                    setIsSpecialOfferDay(
                        specialOfferDateStart <=
                        currentDateString &&
                        currentDateString <=
                        specialOfferDateEnd
                    );

                } else {

                    setError(
                        "Failed to fetch membership form information."
                    );

                }


                setLoadFormInput(false);

            })

            .catch((error) => {

                console.error(error);

                setError(error.message);

                setLoadFormInput(false);

            });

    }, []);


    /* =====================================================
       LOAD MEMBERS
    ===================================================== */

    useEffect(() => {

        axios
            .get(memberUrl)

            .then((response) => {

                if (response.data !== "") {

                    setMembers(
                        response.data
                    );

                } else {

                    setError(
                        "Failed to fetch members data."
                    );

                }


                setLoadMembersData(false);

            })

            .catch((error) => {

                console.error(error);

                setError(error.message);

                setLoadMembersData(false);

            });

    }, []);


    /* =====================================================
       VALIDATE PARENT MEMBER ID
    ===================================================== */

    const validateParentsID = (value) => {

        setParentsId(value);


        if (!members) {
            return;
        }


        if (value.length >= 4) {

            const enteredId =
                value
                    .trim()
                    .toUpperCase();


            const memberIds =
                members.ids || [];


            const memberIndex =
                memberIds.findIndex(
                    (id) =>
                        String(id)
                            .trim()
                            .toUpperCase() ===
                        enteredId
                );


            if (memberIndex !== -1) {

                const parentsName =
                    members.names[
                    memberIndex
                    ];


                setValidMember(true);

                setParentsInfo(
                    "Parent's Name: " +
                    parentsName
                );

            } else {

                setValidMember(false);

                setParentsInfo(
                    "Could not find your parent's Member ID."
                );

            }

        } else {

            setValidMember(null);

            setParentsInfo("");

        }

    };


    /* =====================================================
       CALCULATE AGE
    ===================================================== */

    const calculateAge = (birthDate) => {

        if (!birthDate) {
            return null;
        }


        const today =
            new Date();

        const birth =
            new Date(birthDate);


        let age =
            today.getFullYear() -
            birth.getFullYear();


        const monthDiff =
            today.getMonth() -
            birth.getMonth();


        if (
            monthDiff < 0 ||
            (
                monthDiff === 0 &&
                today.getDate() <
                birth.getDate()
            )
        ) {

            age--;

        }


        return age;

    };


    /* =====================================================
       DATE CHANGE
    ===================================================== */

    const handleDateChange = (date) => {

        if (date) {

            const age =
                calculateAge(date);


            setIsJunior(
                age <
                Number(
                    inputData.junior_max_age
                )
            );


            if (
                age >=
                Number(
                    inputData.junior_max_age
                )
            ) {

                setParentsId("");
                setParentsInfo("");
                setValidMember(null);

            }

        } else {

            setIsJunior(false);

            setParentsId("");
            setParentsInfo("");
            setValidMember(null);

        }

    };


    /* =====================================================
       SEND EMAIL
    ===================================================== */

    const sendEmail = (formData) => {

        const emailData =
            new FormData();


        for (
            const [key, value]
            of formData.entries()
        ) {

            emailData.append(
                key,
                value
            );

        }


        emailData.append(
            "request",
            "memberRegistrationEmail"
        );


        axios
            .post(
                apiUrl,
                emailData
            )

            .then((response) => {

                setTitle(
                    "Registration Completed"
                );

                setMessage(
                    response.data
                );

                setModalShow(true);


                const form =
                    document.getElementById(
                        "memberForm"
                    );


                if (form) {
                    form.reset();
                }


                setIsJunior(false);
                setParentsId("");
                setParentsInfo("");
                setValidMember(null);


                const registerButton =
                    document.getElementById(
                        "register"
                    );


                if (registerButton) {

                    registerButton.disabled =
                        false;

                }

            })

            .catch((error) => {

                console.error(error);

                setTitle(
                    "Registration Completed"
                );

                setMessage(
                    "Your registration was saved, but the confirmation email could not be sent."
                );

                setModalShow(true);


                const registerButton =
                    document.getElementById(
                        "register"
                    );


                if (registerButton) {

                    registerButton.disabled =
                        false;

                }

            });

    };


    /* =====================================================
       SUBMIT REGISTRATION
    ===================================================== */

    function Submit(e) {

        e.preventDefault();


        if (
            isJunior &&
            !validMember
        ) {

            setTitle(
                "Parent Member ID Required"
            );

            setMessage(
                "Please enter a valid parent Member ID before registering."
            );

            setModalShow(true);

            return;

        }


        const form =
            document.getElementById(
                "memberForm"
            );


        const registerButton =
            document.getElementById(
                "register"
            );


        if (registerButton) {

            registerButton.disabled =
                true;

        }


        const formData =
            new FormData(form);


        if (isJunior) {

            formData.append(
                "Group",
                "Junior"
            );

        }


        axios
            .post(
                url,
                formData
            )

            .then((response) => {

                if (
                    response.data.status ===
                    "successful"
                ) {

                    formData.append(
                        "Code",
                        response.data.code
                    );


                    sendEmail(
                        formData
                    );

                } else {

                    setTitle(
                        "Warning"
                    );

                    setMessage(
                        typeof response.data ===
                            "string"
                            ? response.data
                            : JSON.stringify(
                                response.data
                            )
                    );

                    setModalShow(true);


                    if (registerButton) {

                        registerButton.disabled =
                            false;

                    }

                }

            })

            .catch((error) => {

                console.error(error);

                setTitle(
                    "Failed to Register"
                );

                setMessage(
                    error.message
                );

                setModalShow(true);


                if (registerButton) {

                    registerButton.disabled =
                        false;

                }

            });

    }


    /* =====================================================
       LOADING
    ===================================================== */

    const loading =
        loadFormInput ||
        loadMembersData;


    /* =====================================================
       RENDER
    ===================================================== */

    return (

        <main className="register-member-page">


            {/* =========================================
                HERO
            ========================================= */}

            <section className="register-member-hero">

                <div className="container register-member-hero-content">

                    <span className="register-member-label">
                        সদস্যপদ
                    </span>

                    <h1>
                        সদস্য হিসেবে নিবন্ধন করুন
                    </h1>

                    <p>
                        আমরা-আমরা পরিবারের একজন সদস্য হয়ে
                        আমাদের সামাজিক ও সাংস্কৃতিক কার্যক্রমে
                        অংশ নিন।
                    </p>

                </div>

            </section>


            {/* =========================================
                CONTENT
            ========================================= */}

            <section className="register-member-content">

                <div className="container">

                    <div className="register-member-wrapper">


                        {/* FORM HEADING */}

                        <div className="register-form-heading">

                            <span>
                                MEMBERSHIP
                            </span>

                            <h2>
                                Member Registration Form
                            </h2>

                            <p>
                                Please provide your information below.
                                Fields marked with * are required.
                            </p>

                        </div>


                        {/* =====================================
                            LOADING
                        ===================================== */}

                        {loading && (

                            <div className="register-member-loading">

                                <div className="register-member-spinner"></div>

                                <span>
                                    Please wait while loading the form...
                                </span>

                            </div>

                        )}


                        {/* =====================================
                            ERROR
                        ===================================== */}

                        {!loading && error && (

                            <div className="register-member-error">

                                <strong>
                                    Unable to load registration information
                                </strong>

                                <span>
                                    {error}
                                </span>

                            </div>

                        )}


                        {/* =====================================
                            FORM
                        ===================================== */}

                        {!loading && !error && (

                            <form
                                id="memberForm"
                                className="register-member-form"
                                onSubmit={Submit}
                            >


                                {/* =============================
                                    1. PERSONAL INFORMATION
                                ============================= */}

                                <div className="register-form-section">


                                    <div className="register-form-section-title">

                                        <span className="section-number">
                                            1
                                        </span>

                                        <div>

                                            <h3>
                                                Personal Information
                                            </h3>

                                            <p>
                                                Tell us a little about yourself.
                                            </p>

                                        </div>

                                    </div>


                                    {/* NAME */}

                                    <div className="register-field">

                                        <label htmlFor="memberName">

                                            Full Name
                                            <span>*</span>

                                        </label>

                                        <input
                                            id="memberName"
                                            name="Name"
                                            type="text"
                                            placeholder="Enter your full name"
                                            required
                                        />

                                    </div>


                                    {/* DATE OF BIRTH */}

                                    <div className="register-field">

                                        <label>
                                            Date of Birth
                                            <span>*</span>
                                        </label>


                                        <div className="member-date-field">

                                            <AmraAmraDatePicker
                                                value="DateOfBirth"
                                                placeHolderText="Example: 1995-12-22"
                                                onDateChange={
                                                    handleDateChange
                                                }
                                            />


                                            {isJunior && (

                                                <span className="junior-badge">
                                                    Junior Member
                                                </span>

                                            )}

                                        </div>

                                    </div>


                                    {/* PARENT ID */}

                                    {isJunior && (

                                        <div className="register-field junior-parent-field">

                                            <label htmlFor="parentsId">

                                                Parent's Member ID
                                                <span>*</span>

                                            </label>


                                            <input
                                                id="parentsId"
                                                name="ParentsId"
                                                type="text"
                                                placeholder="Example: M012"
                                                value={
                                                    parentsId
                                                }
                                                onChange={(e) =>
                                                    validateParentsID(
                                                        e.target.value
                                                    )
                                                }
                                                required
                                            />


                                            {parentsInfo && (

                                                <div
                                                    className={
                                                        validMember
                                                            ? "parent-validation valid"
                                                            : "parent-validation invalid"
                                                    }
                                                >

                                                    <span>
                                                        {validMember
                                                            ? "✓"
                                                            : "!"}
                                                    </span>

                                                    <span>
                                                        {parentsInfo}
                                                    </span>

                                                </div>

                                            )}

                                        </div>

                                    )}

                                </div>


                                {/* =============================
                                    2. CONTACT INFORMATION
                                ============================= */}

                                <div className="register-form-section">


                                    <div className="register-form-section-title">

                                        <span className="section-number">
                                            2
                                        </span>

                                        <div>

                                            <h3>
                                                Contact Information
                                            </h3>

                                            <p>
                                                How can we contact you?
                                            </p>

                                        </div>

                                    </div>


                                    <div className="register-fields-grid">


                                        {/* EMAIL */}

                                        <div className="register-field">

                                            <label htmlFor="memberEmail">

                                                Email

                                                {!isJunior && (
                                                    <span>*</span>
                                                )}

                                            </label>


                                            <input
                                                id="memberEmail"
                                                name="Email"
                                                type="email"
                                                placeholder={
                                                    isJunior
                                                        ? "Email address (optional)"
                                                        : "Email address"
                                                }
                                                required={
                                                    !isJunior
                                                }
                                            />

                                        </div>


                                        {/* PHONE */}

                                        <div className="register-field">

                                            <label htmlFor="memberPhone">

                                                Phone

                                                {!isJunior && (
                                                    <span>*</span>
                                                )}

                                            </label>


                                            <input
                                                id="memberPhone"
                                                name="Phone"
                                                type="tel"
                                                placeholder={
                                                    isJunior
                                                        ? "Phone number (optional)"
                                                        : "Phone number"
                                                }
                                                required={
                                                    !isJunior
                                                }
                                            />

                                        </div>

                                    </div>


                                    {/* ADDRESS */}

                                    <div className="register-field">

                                        <label htmlFor="memberAddress">

                                            Address
                                            <span>*</span>

                                        </label>


                                        <input
                                            id="memberAddress"
                                            name="Address"
                                            type="text"
                                            placeholder="Your address"
                                            required
                                        />

                                    </div>

                                </div>


                                {/* =============================
                                    3. MEMBERSHIP FEE
                                ============================= */}

                                <div className="register-form-section">


                                    <div className="register-form-section-title">

                                        <span className="section-number">
                                            3
                                        </span>

                                        <div>

                                            <h3>
                                                Membership Fee
                                            </h3>

                                            <p>
                                                Complete your membership payment.
                                            </p>

                                        </div>

                                    </div>


                                    <div className="membership-fee-card">


                                        {/* JUNIOR */}

                                        {isJunior && (

                                            <div className="membership-price">

                                                <span>
                                                    Junior Membership
                                                </span>


                                                <strong>

                                                    {isSpecialOfferDay
                                                        ? inputData.discounted_junior_fee
                                                        : inputData.junior_fee}

                                                    <small>
                                                        {" "}kr
                                                    </small>

                                                </strong>

                                            </div>

                                        )}


                                        {/* ADULT SPECIAL OFFER */}

                                        {!isJunior &&
                                            isSpecialOfferDay && (

                                                <>

                                                    <div className="membership-offer-badge">
                                                        Special Offer
                                                    </div>


                                                    <div className="membership-price">

                                                        <span>
                                                            Adult Membership
                                                        </span>


                                                        <div>

                                                            <del>
                                                                {inputData.adult_fee} kr
                                                            </del>


                                                            <strong>

                                                                {inputData.discounted_adult_fee}

                                                                <small>
                                                                    {" "}kr
                                                                </small>

                                                            </strong>

                                                        </div>

                                                    </div>

                                                </>

                                            )}


                                        {/* NORMAL ADULT */}

                                        {!isJunior &&
                                            !isSpecialOfferDay && (

                                                <div className="membership-price">

                                                    <span>
                                                        Adult Membership
                                                    </span>


                                                    <strong>

                                                        {inputData.adult_fee}

                                                        <small>
                                                            {" "}kr
                                                        </small>

                                                    </strong>

                                                </div>

                                            )}


                                        {/* PAYMENT DETAILS */}

                                        <div className="membership-payment">


                                            <div>

                                                <span>
                                                    Bankgiro
                                                </span>

                                                <strong>
                                                    577-0623
                                                </strong>

                                            </div>


                                            <div>

                                                <span>
                                                    Swish
                                                </span>

                                                <strong>
                                                    1230432419
                                                </strong>

                                            </div>

                                        </div>


                                        {/* PAYMENT CONFIRMATION */}

                                        <label
                                            className="membership-confirmation"
                                            htmlFor="swish"
                                        >

                                            <input
                                                type="checkbox"
                                                name="Swish"
                                                id="swish"
                                                required
                                            />


                                            <span className="membership-checkbox"></span>


                                            <span>

                                                I have paid the membership fee.

                                                <small>
                                                    Please complete the payment
                                                    before submitting your
                                                    registration.
                                                </small>

                                            </span>

                                        </label>

                                    </div>

                                </div>


                                {/* =============================
                                    SUBMIT
                                ============================= */}

                                <div className="register-member-submit">

                                    <button
                                        type="submit"
                                        id="register"
                                    >

                                        Complete Registration

                                        <span>
                                            →
                                        </span>

                                    </button>


                                    <p>
                                        By registering, you are applying
                                        to become a member of Amra-Amra.
                                    </p>

                                </div>

                            </form>

                        )}

                    </div>

                </div>

            </section>


            {/* =========================================
                NOTIFICATION
            ========================================= */}

            <Notification
                show={modalShow}
                onHide={() =>
                    setModalShow(false)
                }
                title={title}
                message={message}
            />

        </main>

    );

}


export default RegisterMember;